import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {STATUS_FAILED, STATUS_IDLE, STATUS_PENDING} from "../../constants";
import {firestore, auth} from "../../config/firebaseConfig";
import {fetchOrders} from "./orders";

const ProductsSlice = createSlice({
    name: 'orders/items',
    initialState: {
        list: null,
        cursor: null,
        keyword: null,
        status: STATUS_IDLE
    },
    reducers: {
        pending: (state) => {
            state.status = STATUS_PENDING
        },
        failed: (state) => {
            state.status = STATUS_FAILED
        },
        setValue: (state, action) => {
            state.list = action.payload;
            state.status = STATUS_IDLE
        },
        setCursor: (state, action) => {
            state.cursor = action.payload;
        },
        setKeyword: (state, action) => {
            state.keyword = action.payload;
        },
    }
})

const {failed, pending, setValue, setCursor, setKeyword} = ProductsSlice.actions

export const selectProductList = state => state.productList;

export default ProductsSlice.reducer;

export const searchProducts = createAsyncThunk(
    'orders/items/search',
    async ({keyword = '', limit = 10}, thunkAPI) => {
        try {
            const {cursor, keyword: previousKeyword} = thunkAPI.getState().productList

            thunkAPI.dispatch(pending())

            let queryRef = firestore.collection('items').limit(limit);

            if (keyword && keyword.length !== 0)
                queryRef = queryRef.where('SearchKeys', 'array-contains', keyword.toUpperCase())

            if (keyword === previousKeyword)
                queryRef = queryRef.startAfter(cursor)

            const docSnap = await queryRef.get();

            let result = [];

            docSnap.forEach(doc => {
                result.push({
                    Id: doc.id,
                    ImageUrl: doc.data().ImageUrl,
                    InternalId: doc.data().InternalId,
                    Barcode: doc.data().Barcode,
                    Name: doc.data().Name,
                })
            })

            thunkAPI.dispatch(setValue(result))
            thunkAPI.dispatch(setKeyword(keyword))
            thunkAPI.dispatch(setCursor(docSnap.docs[docSnap.docs.length - 1]))

            // thunkAPI.dispatch(fetchOrders({}))

        } catch (e) {
            console.log(e)
            thunkAPI.dispatch(failed())
        }

    }
)

export const createOrder = createAsyncThunk(
    'orders/create',
    async ({data, onResolve}, thunkAPI) => {
        try {

            const cptSnap = await firestore.collection('reference_stories').doc('orderId').get()
            const cpt = cptSnap.data().cpt

            const id = auth.currentUser.uid;

            const result = await firestore.collection('users').doc(id).get()

            const currentUser = {
                Id: id,
                Name: result.data()?.name || result.data()?.displayName || auth?.currentUser?.displayName || '',
                AvatarUrl: result.data()?.avatar_url || result.data()?.photoUrl || result.data()?.AvatarUrl || null,
                Email: auth?.currentUser?.email || ''
            };


            await firestore.collection('orders').add({
                ...data,
                Issuer: currentUser,
                Order: {...data.Order, Number: cpt}
            });


            await firestore.collection('reference_stories').doc('orderId').update({cpt: cpt + 1})

            const {snapshot: {filter}} = thunkAPI.getState().orders;

            thunkAPI.dispatch(fetchOrders({filter: filter, forceReset: true}))

            onResolve && onResolve()

        } catch
            (e) {
            console.log(e)
        }
    }
)

export const updateOrder = createAsyncThunk(
    'orders/update',
    async ({data, onResolve}, thunkAPI) => {
        try {

            let copy = {...data}
            delete copy.id

            await firestore.collection('orders').doc(data.id).update(copy);

            const {snapshot: {filter}} = thunkAPI.getState().orders;

            thunkAPI.dispatch(fetchOrders({filter: filter, forceReset: true}))

            onResolve && onResolve()

        } catch (e) {
            console.log(e)
        }
    }
)

